const options = {
  5: "bg-cyan-100/5",
  10: "bg-cyan-100/10",
  25: "bg-cyan-100/25",
  50: "bg-cyan-100/50",
  75: "bg-cyan-100/75",
  90: "bg-cyan-100/90",
  100: "bg-cyan-100",
};

const from = {
  5: "from-cyan-100/5",
  10: "from-cyan-100/10",
  25: "from-cyan-100/25",
  50: "from-cyan-100/50",
  75: "from-cyan-100/75",
  90: "from-cyan-100/90",
  100: "from-cyan-100",
};

export default function getBackgroundCyan100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
